import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import compareSize from "../../helpers/compareSize"
import makeImageLabels from "../../helpers/makeImageLabels"
import printImage from "../../helpers/printImage"
import {listLineship} from "../../helpers/filtersTable"

class ExportQr extends Component {
    _LineShipName = (lineShip) => {
        if (!!lineShip) {
            const mappingLineShips = [
                ...listLineship,
                {value: 'usps_mn_ib_blue', name: 'USPS-IB'},
                {value: 'ib_blue_usps_mn', name: 'IB-USPS'},
            ]
            const lineShipName = mappingLineShips.filter(item => item.value === lineShip)
    
            return lineShipName[0]
        }
    }

    _parseLabels = (items) => {
        const results = []
        const usex = ['PR', 'AE', 'AP', 'AO', 'VI', 'AA']

        for (const item of items) {
            const {barcodeNumber, country, state, production_status, tags, labelDetails, order_type} = {...item}
            const {shipping_carrier, meta} = {...labelDetails}
            let {products} = {...item}

            const lineShipName = shipping_carrier ? (!!this._LineShipName(shipping_carrier) && !!this._LineShipName(shipping_carrier).name ? this._LineShipName(shipping_carrier).name : '') : ''

            let line_ship_label = lineShipName === "ZONE9_US" ? "HW_Z9" : lineShipName === "ZONE9_CA" ? "Z9_CA" : lineShipName
            let hwUSPSArea = ''

            if (item.hasOwnProperty('filteredProducts')) {
                products = item.filteredProducts
            }

            if (['hw_usps'].includes(shipping_carrier)) {
                hwUSPSArea = meta && meta.area || 'NY'
            }

            if (['hw_tiktok', 'hw_ttship', 'hw_gb', 'hw_gb_ttship'].includes(shipping_carrier)) {
                hwUSPSArea = meta && meta.area || ''
            }

            if (!['on-hold', 'cancelled'].includes(production_status)) {
                for (const i in products) {
                    const product = products[i]
                    const {color, size, designFront, designBack, designSleeveLeft, designSleeveRight, brand_name = ''} = product || {}
                    const pos = product.hasOwnProperty('pos') ? product.pos : (parseInt(i) + 1)
                    const side = `${designFront ? 'F' : ''}${designBack ? 'B' : ''}${(designSleeveLeft || designSleeveRight) ? '-' : ''}${designSleeveLeft ? 'L' : ''}${designSleeveRight ? 'R' : ''}`
                    const type = product.type
                    const isFastProduction = Array.isArray(tags) && tags.includes('fastproduction')
                    const isCutoff = Array.isArray(tags) && tags.includes('cutoff')
                    const isHQ = Array.isArray(tags) && (tags.includes('HQ') || tags.includes('HQ gap'))

                    let loc = ''

                    if (country.toUpperCase() === 'US' && usex.indexOf(state.toUpperCase()) !== -1) {
                        loc = 'WW'
                    } else {
                        loc = country.toUpperCase()
                    }
                    if (['HW_YUN'].includes(line_ship_label) && ['AT', 'CZ', 'DE', 'HU', 'IT', 'LU', 'NL', 'PL'].includes(loc) && !tags.includes('force-yun')) {
                        line_ship_label = 'HW_EU'
                    }
                    const label = {
                        orderId: `${barcodeNumber}_${pos}`,
                        total: item.products.length,
                        pos: pos,
                        posColor: item.products.length > 1 ? 'white' : 'black',
                        posBackground: item.products.length > 1 ? 'black' : 'white',
                        color: color,
                        size: size,
                        side: side,
                        sideBackground: side === 'F' ? 'white' : 'black',
                        type: type,
                        loc: loc,
                        isFastProduction,
                        isCutoff,
                        isHQ,
                        line_ship_label,
                        hwUSPSArea,
                        order_type,
                        tags: tags,
                        brand_name: Array.isArray(brand_name) ? brand_name.join(', ') : (brand_name || ''),
                    }
                    results.push(label)
                }
            }
        }

        const sortedLabels = [...results].sort((a, b) => {
            if (a.color > b.color) return 1
            if (a.color < b.color) return -1

            const cpSize = compareSize(a.size, b.size)

            if (cpSize) return cpSize

            if (a.side > b.side) return 1
            if (a.side < b.side) return -1
            if (a.orderId > b.orderId) return 1
            if (a.orderId < b.orderId) return -1
            if (a.orderId > b.orderId) return -1
            if (a.orderId < b.orderId) return 1

            return 0
        })

        return sortedLabels
    }

    _handlePrintLabels = async () => {
        try {
            const {items} = this.props
            const labels = this._parseLabels(items)
            const image = await makeImageLabels(labels, false, 460, 170, 'admin')

            printImage(image)
        } catch (e) {
            alert(e.message)
        }
    }

    render() {
        return (
            <Button className="btn btn-danger btn-labeled btn-labeled-left ml-1"
                    onClick={this._handlePrintLabels}>
                <b><i className="icon-qrcode"/></b>
                In mã QR
            </Button>
        )
    }
}

ExportQr.propTypes = {
    items: PropTypes.array.isRequired
}

export default ExportQr
